export class ContentNotification {
  id: any;
  label: any;
  feedLabel: any;
  advisioriesLabel: any;
  advisioriesViewAllLink: any;
  advisoriesViewNewWindow: any;
  newsLabel: any;
  newsViewAllLink: any;
  newsViewNewWindow: any;
  viewAllLabel: any;
  viewAllLink: any;
  newsViewAllLabel: any;
  advisoriesViewAllLabel: any;
  notificationLabel: any;
  notificationViewAllLabel: any;
  notificationViewAllLink: any;
  notificationViewNewTab: any;

  constructor(contentjson?: any) {
    if (contentjson) {
      if (contentjson['id']) {
        this.id = contentjson['id'];
      }
      if (contentjson['feedLabel']) {
        this.feedLabel = contentjson['feedLabel'];
      }
      if (contentjson['label']) {
        this.label = contentjson['label'];
      }
      if (contentjson['advisioriesLabel']) {
        this.advisioriesLabel = contentjson['advisioriesLabel'];
      }
      if (contentjson['advisioriesViewAllLink']) {
        this.advisioriesViewAllLink = contentjson['advisioriesViewAllLink'];
      }
      if (contentjson['newsLabel']) {
        this.newsLabel = contentjson['newsLabel'];
      }
      if (contentjson['newsViewAllLink']) {
        this.newsViewAllLink = contentjson['newsViewAllLink'];
      }
      if (contentjson['newsViewNewWindow']) {
        this.newsViewNewWindow = contentjson['newsViewNewWindow'];
      }
      if (contentjson['advisoriesViewNewWindow']) {
        this.advisoriesViewNewWindow = contentjson['advisoriesViewNewWindow'];
      }
      if (contentjson['viewAllLabel']) {
        this.viewAllLabel = contentjson['viewAllLabel'];
      }
      if (contentjson['viewAllLink']) {
        this.viewAllLink = contentjson['viewAllLink'];
      }
      if (contentjson['newsViewAllLabel']) {
        this.newsViewAllLabel = contentjson['newsViewAllLabel'];
      }
      if (contentjson['advisoriesViewAllLabel']) {
        this.advisoriesViewAllLabel = contentjson['advisoriesViewAllLabel'];
      }
      if (contentjson['notificationLabel']) {
        this.notificationLabel = contentjson['notificationLabel'];
      }
      if (contentjson['notificationViewAllLabel']) {
        this.notificationViewAllLabel = contentjson['notificationViewAllLabel'];
      }
      if (contentjson['notificationViewAllLink']) {
        this.notificationViewAllLink = contentjson['notificationViewAllLink'];
      }
      if (contentjson['notificationViewNewTab']) {
        this.notificationViewNewTab = contentjson['notificationViewNewTab'];
      }
    }
  }
}
